var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:("button-color--" + _vm.color),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v(" Test 2: "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }